<h2>Durchgangsarzt</h2>
<p>Arbeits-, Dienst- und Schulunfälle sowie Berufskrankheiten sind in der gesetzlichen Unfallversicherung über die
  Berufsgenossenschaften bzw. den Unfallkassen versichert.</p>
<p>Die Behandlung in diesen Fällen ist speziell qualifizierten Ärzten (in der Regel sog. D-Ärzte), die von den
  Unfallversicherungsträgern hierzu ermächtigt wurden, vorbehalten.</p>
<p>Durch meine langjährige Tätigkeit als stellvertretender Durchgangsarzt in einer Unfallchirurgischen Klinik mit
  Zulassung zum Schwerverletztenverfahren habe ich die Genehmigung sämtliche Arbeits-, Dienst- und Schulunfälle sowie
  Berufserkrankungen im Auftrag der Berufsgenossenschaften und Unfallkassen zu behandeln.</p>
<p>Auch die Ermächtigung zur Begutachtung im Rentenverfahren der Berufsgenossenschaften und Unfallkassen liegt vor.</p>
